// extracted by mini-css-extract-plugin
export var cartContainer = "_ju-4";
export var gray = "_ju-1";
export var itemContainer = "_ju-2";
export var itemDetails = "_ju-3";
export var strong = "_ju-0";